import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView.ReportAccessActionRow`

export default defineMessages({
  addButtonLabel: {
    id: `${scope}.addButtonLabel`,
    defaultMessage: 'Add',
  },
  submitButtonLabel: {
    id: `${scope}.submitButtonLabel`,
    defaultMessage: 'Submit',
  },
  addActionLabel: {
    id: `${scope}.addActionLabel`,
    defaultMessage: 'Add',
  },
  removeActionLabel: {
    id: `${scope}.removeActionLabel`,
    defaultMessage: 'Remove',
  },
  removeHelperText: {
    id: `${scope}.removeHelperText`,
    defaultMessage:
      "* The selected user's reports access will be revoked from all {pluralPrimaryOrgCategoryLabel} and {pluralSecondaryOrgCategoryLabel}",
  },
})
